export default __webpack_public_path__ + "static/detail_view-d54b65041b8b88bf63b014a31d1199b8.gif";